import { defineField } from 'sanity'

/**
 * Shared SEO fields used across pageInfo, fitmentGuidePageInfo, and galleryPageInfo
 */
export const seoFields = [
  defineField({
    title: 'Title',
    name: 'title',
    type: 'string',
    description: 'Meta Title',
  }),
  defineField({
    title: 'Description',
    name: 'description',
    type: 'string',
    description: 'Meta Description',
  }),
  defineField({
    name: 'metaImage',
    title: 'Meta Image',
    type: 'image',
    options: {
      hotspot: true,
    },
  }),
  defineField({
    title: 'Keywords',
    name: 'keywords',
    type: 'string',
    description: 'Meta Keywords',
  }),
  defineField({
    title: 'No index',
    name: 'noindex',
    type: 'boolean',
    initialValue: false,
    description: 'Prevent this page from showing in search engine results',
  }),
  defineField({
    title: 'No follow',
    name: 'nofollow',
    type: 'boolean',
    initialValue: false,
    description:
      'Prevent search engine to associate links on this page with our site.',
  }),
]
